/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Moderation_FailedInputs */



/**
* | output |
* | --- |
* | "Moderation failed" |
*
* @param {Community_Moderation_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_moderation_failed = /** @type {((inputs?: Community_Moderation_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Moderation_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la modération")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de moderación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha na moderação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Moderazione fallita")
	return /** @type {LocalizedString} */ ("Moderation failed")
});